@if (isVisible()) {
  <div class="legend">
    @for (foretag of legendData; track foretag) {
      <div class="legenditem">
        <div class="legendmarker" [ngClass]="foretag.symbolStyle" [ngStyle]="{ 'background-color': foretag.color }"></div>
        <small>{{ foretag.namn }}</small>
      </div>
    }
  </div>
}
